import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import StepTitle from '../atoms/titles/StepTitle';
import LinkButton from '../atoms/button/LinkButton';
import SearchFlightSP from './SearchFlightSP';
import SearchConditionSPFlight from './SearchConditionSPFlight';
import SearchConditionSPHotel from './SearchConditionSPHotel';
import ModalRoundTrip from '../modal/ModalRoundTrip';
import ModalAccommodationConditions from '../modal/ModalAccommodationConditions';

moment.locale('ja');

const SearchBoxSP = ({ affiliate, handleSearchWithCallback, handleFlightSearch, maxStayNights }) => {
  const [ modalRoundTrip, setModalRoundTrip ] = useState(false);
  const [ modalAccommodation, setModalAccommodation ] = useState(false);

  const toggleModalRoundTrip = useCallback(
    () => {
      setModalRoundTrip(!modalRoundTrip);
    },
    [ modalRoundTrip ],
  );

  const toggleModalAccommodation = useCallback(
    () => {
      setModalAccommodation(!modalAccommodation);
    },
    [ modalAccommodation ],
  );

  return (
    <React.Fragment>
      <div className="SearchContentsContainer">
        <div className="SearchContent">
          <StepTitle text="STEP① 日程・航空便選択" />
          <div className="SearchContentItem">
            <div className="SearchContentBody">
              <SearchConditionSPFlight />
              <div className="SearchContentButton" style={{ marginTop: 18 }}>
                <LinkButton onClick={toggleModalRoundTrip}>検索条件を変更する</LinkButton>
              </div>
              <div className="SearchContentPlan">
                <SearchFlightSP handleFlightSearch={handleFlightSearch} />
              </div>
            </div>
          </div>
        </div>
        <div className="SearchContent">
          <StepTitle text={!affiliate ? 'STEP② 宿泊施設選択' : 'STEP② プラン選択'} />
          {!affiliate && (
            <React.Fragment>
              <div className="SearchContentBody">
                <SearchConditionSPHotel handleSearch={() => handleSearchWithCallback(() => {})} />
              </div>
              <div className="SearchContentBody">
                <div className="SearchContentButton">
                  <LinkButton onClick={toggleModalAccommodation}>宿泊条件を変更する</LinkButton>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
      <ModalRoundTrip
        open={modalRoundTrip}
        onClose={toggleModalRoundTrip}
        handleSearch={() => handleSearchWithCallback(toggleModalRoundTrip)}
      />
      <ModalAccommodationConditions
        open={modalAccommodation}
        onClose={toggleModalAccommodation}
        handleSearch={() => handleSearchWithCallback(toggleModalAccommodation)}
        maxStayNights={maxStayNights}
      />
    </React.Fragment>
  );

};

SearchBoxSP.propTypes = {
  affiliate: PropTypes.bool,
  handleSearchWithCallback: PropTypes.func.isRequired,
  handleFlightSearch: PropTypes.func.isRequired,
  maxStayNights: PropTypes.number,
};

export default SearchBoxSP;
